import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getLookbookSummary({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.summary, id, signal });

    const preparedData = {
      result: {
        ...data.result,
        users: data.result.users.map(x => {
          const userItem = {
            key: x.user.uuid,
            creator: x.user,
            order: x.order,
            links: x.stats?.active_links_count,
            clicks: x.stats?.clicks_count,
            sales: x.stats?.gmv,
            roas: x.stats?.roas
          };

          return {
            ...userItem,
            operations: userItem
          };
        })
        // 'creators_received_delivery_count': 1
      }
    };

    onSuccess && onSuccess(preparedData.result);
    yield put(actions.getLookbookSummaryDone(preparedData.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLookbookSummaryFailed,
      endpoint: api.lookbooks.summary.url
    });
  }
}

export const getLookbookSummarySaga = takeEvery(types.GET_LOOKBOOK_SUMMARY_REQUEST, getLookbookSummary);